// extracted by mini-css-extract-plugin
export default {"hero_banner":"HeroBanner_hero_banner__dPCnk"};